<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <page-title title="Interventions" />
    @if (canCreate()) {
      <a mat-flat-button routerLink="/interventions/new">Create intervention</a>
    }
  </div>
  <intervention-table
    [interventions]="store.interventions()"
    [loading]="store.loading()"
    [searchTerm]="store.search()"
    [pageNumber]="store.pageNumber()"
    [pageSize]="store.pageSize()"
    [totalCount]="store.totalCount()"
    [totalPages]="store.totalPages()"
    (refreshed)="store.load()"
    (searchChanged)="search($event)"
    (pageChanged)="pageChanged($event)"
  />
</section>
